export default __webpack_public_path__ + "static/outwater-dbf12e1da85961aab04640f4226a0f77.jpg";